import jwt from 'jsonwebtoken';
import jwkToPem from 'jwk-to-pem';
import axios from 'axios';

import { appConfig } from './config';

const wellKnownAuthPath = appConfig.authWellKnownPath;

function getDecodedToken(token) {
  const decodedToken = jwt.decode(token, { complete: true });
  return decodedToken;
}

function getJwkKid(decodedToken) {  
  const jwkKid = decodedToken.header.kid
  return jwkKid;
}

function getWellKnownUri(decodedToken) {
  const issuer = decodedToken.payload.iss;
  const wellKnownUri = issuer + wellKnownAuthPath;
  return wellKnownUri
}

async function getJwksUri(uri) {
  const response = await axios.get(uri);
  const jwksUri =  response.data.jwks_uri;
  return jwksUri;
}

async function getJwks(uri) {
  const response = await axios.get(uri);
  const jwks = response.data;
  return jwks;
}

export function decodeToken(token) {
  try {
    const decodedToken = getDecodedToken(token);
    const jwkKid = getJwkKid(decodedToken);
    const wellKnownUri = getWellKnownUri(decodedToken);
    
    return getJwksUri(wellKnownUri)
      .then(jwksUri => getJwks(jwksUri))
      .then(jwks => {
        const matchedJwks = jwks.keys.filter((jwk) => {
          return jwk.kid === jwkKid;
        });
        // TODO error handling
        return matchedJwks[0];
      })
      .then(jwk => {
        const result = { 
          decodedToken: decodedToken,
          jwk: jwk
        };
        try {
          const verifiedToken = jwt.verify(token, jwkToPem(jwk));
          if (verifiedToken) {
            result.status = 'OK';
            result.message = 'Token is valid';
          }
        } catch(error) {
          let errorProps = [];
          for (let key in error) {
            typeof error[key] !== 'function' && errorProps.push(key + ": " + error[key]);
          }
          result.status = 'Error';
          result.message = errorProps;
        }
        return result;
      });
    } catch(error) {
      // TODO error handling
      console.error(error);
    } 
  }
